








































































helpers = require('../../helpers.coffee')

view_model = {
  components:
    contactPicker: require '../contacts/picker'
    contactManualPicker: require '../contacts/manual_picker'

  data: ->
    current_user: Session.current_user
    contact_group: new ContactGroup(id: @$route.params.id)
    loaded_contacts: []
    selected_contacts: []
    new_contacts: []
    contact_ids_to_be_removed: []
    original_group_name: ''
    next_page: 1
    fetching: false
    user_filters: {}

  computed:
    filters: ->
      merged_filters = @user_filters
      merged_filters.contact_group_id_eq = @contact_group.id
      merged_filters

    filtered_selected_contacts: ->
      @selected_contacts.filter (contact) => @filterContact(contact, @filters)

    filtered_new_contacts: ->
      @new_contacts.filter (contact) => @filterContact(contact, @filters)

    contacts: ->
      @loaded_contacts.concat(@filtered_selected_contacts, @filtered_new_contacts)

    contacts_count: ->
      @contact_group.contacts_count + @selected_contacts.length + @new_contacts.length - @contact_ids_to_be_removed.length

  methods:
    setContactGroup: (contact_group) ->
      @contact_group = contact_group
      @original_group_name = @contact_group.name

    loadContactGroup: ->
      Loader.on()
      @contact_group_resource.get @loadContactGroupSuccess, @unknownError, id: @$route.params.id

    loadContactGroupSuccess: (resources) ->
      @setContactGroup resources.contact_group
      Loader.off()

    loadContacts: ->
      return if @fetching || !@next_page
      @fetching = true
      @contact_resource.index @loadContactsSuccess, @unknownError, params: { q: @filters, page: @next_page }

    loadContactsSuccess: (resources) ->
      @next_page = if resources.meta then resources.meta.next_page else null
      @loaded_contacts = @loaded_contacts.concat(resources.contacts)
      @fetching = false

    filter: (filters) ->
      @user_filters = filters
      @loaded_contacts = []
      @next_page = 1
      @loadContacts()

    removeContactFromList: (contact, list) ->
      index = list.findIndex contact
      list.splice index, 1 if index > -1

    removeFromGroup: (data) ->
      if data.contact.id
        if(data.contact.contact_group)
          @removePersistedContact(data.contact)
        else
          @removeSelectedContact(data.contact)
      else
        @removeNewContact(data.contact)

    removeNewContact: (contact) ->
      @removeContactFromList(contact, @new_contacts)

    removeSelectedContact: (contact) ->
      @removeContactFromList contact, @selected_contacts
      EventsBus.$emit 'ContactsPicker:AddContact', { contact: contact, selected: false }

    removePersistedContact: (contact) ->
      @contact_ids_to_be_removed.push(contact.id)
      @removeContactFromList contact, @loaded_contacts
      EventsBus.$emit 'ContactsPicker:AddContact', { contact: contact, selected: false }

    saveGroup: ->
      Loader.on()
      @contact_group.contacts = @contacts
      @contact_group.contact_ids_to_be_removed = @contact_ids_to_be_removed
      @contact_group_resource.update @saveSuccess, @unknownError, @contact_group.serialize()

    saveSuccess: (data) ->
      @original_group_name = data.contact_group.name
      Loader.off()
      @$router.push path: '/contatos/grupos'
      alertify.success 'Grupo salvo com sucesso! Os contatos serão inseridos no grupo.'
      @trackIntercomGroupUpdate(data.contact_group)

    addContactsToGroup: (data) ->
      self = this
      data.contacts.forEach (contact) =>
        contact.user = @contact_group.user
        contact.stage = 'smart_lead'
        contact.human_stage = 'Smart Lead'
        contact.recipient_status = 'not_connected'
        contact.human_recipient_status = 'Sem Conexão'
        @new_contacts.push contact

    selectContacts: (data) ->
      data.contacts.forEach (contact) =>
        index = @contact_ids_to_be_removed.indexOf contact.id
        if index > -1
          @contact_ids_to_be_removed.splice index, 1 if index > -1
          @loaded_contacts.push(contact)
        else
          index = @selected_contacts.findIndex contact
          @selected_contacts.push(contact) if index < 0
        EventsBus.$emit 'ContactsPicker:RemoveContact', contact

    filterContact: (contact, filters) ->
      (!filters.search_query || contact.full_name.toLowerCase().indexOf(filters.search_query.toLowerCase()) > -1) &&
      (!filters.stage_eq || contact.stage == filters.stage_eq) &&
      (!filters.current_recipient_status_eq || contact.recipient_status == filters.current_recipient_status_eq) &&
      (!filters.contact_tags_tag_id_eq || contact.tags.some (tag) => tag.id == filters.contact_tags_tag_id_eq)

    trackIntercomGroupUpdate: (contact_group) ->
      metadata =
        id: contact_group.id
        'Nome': contact_group.name
        'Quantidade de contatos': contact_group.contacts_count
      IntercomCtrl.trackEvent('Editou um grupo', metadata)

  created: ->
    @contact_group_resource = new ContactGroupsResource Session.current_company.id
    @contact_resource = new ContactsResource Session.current_company.id

    @loadContactGroup()
    @loadContacts()

    EventsBus.$on 'contact-picker-contacts-added', @addContactsToGroup

  beforeDestroy: ->
    EventsBus.$off 'contact-picker-contacts-added', @addContactsToGroup
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_wrapper, helpers.contacts.list_view_modes)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contact_groups/edit.vue